module.exports = __webpack_public_path__ + "static/media/Nav-logo2.ec089f82.svg";